import { gsap } from 'gsap';
import { throttle } from "../helpers";

(function($, window) {
    /////////////// BURGER ANIMATION
    const burgerTop = document.getElementById('burger-bar-top');
    const burgerMiddle = document.getElementById('burger-bar-middle');
    const burgerBottom = document.getElementById('burger-bar-bottom');
    let tl = gsap.timeline();

    const open = () => {
        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 45, duration: 1, y: 7, scaleX: 1.2, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
        tl.to(burgerMiddle, { scaleX: 0, duration: 1, opacity: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
        tl.to(burgerBottom, { rotate: -45, duration: 1, y: -7, scaleX: 1.2, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
    }

    const close = () => {
        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 0, duration: 1, y: 0, scaleX: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
        tl.to(burgerMiddle, { scaleX: 1, duration: 1, opacity: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
        tl.to(burgerBottom, { rotate: 0, duration: 1, y: 0, scaleX: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
    }

    $(window).on('mobileMenuOpen', () => {
        tl.pause();
        open();
    });

    $(window).on('mobileMenuClose', () => {
        tl.pause();
        close();
    });

    /////////////// BURGER ANIMATION

    //////////// MOBILE SEARCH
    const $searchToggle = $('[data-search-mobile]');
    if($searchToggle.length){
        const $mobileUi = $('[data-search-mobile-ui]').height($('.header-bg').innerHeight());
        const $search = $mobileUi.find('[name="q"]');
        const $searchBox = $('.search-box-container');
        const $searchClose = $('[data-search-mobile-close]');
        const $menuToggle = $('.site-nav__mobile-toggle');
        const shiftToTheLeft = (($searchToggle.offset().left - $menuToggle.offset().left) * -1 );

        const focusSearch = function(){ $search.trigger('focus'); };
        const blurSearch = function(){ $search.trigger('blur'); };

        $searchToggle.on('click', function(e){

            const siteHeaderHeight = $('.site-header').height();
            const tl = gsap.timeline({ onComplete: focusSearch });
            tl.to($menuToggle, { x: shiftToTheLeft, autoAlpha: 0 }, 0);
            tl.to($searchBox, { y: siteHeaderHeight, duration: .35 }, 0);
            tl.to($mobileUi, { duration: .2, autoAlpha: 1, duration: .2 }, .3);
            $('body').addClass('search-open');
        });

        $searchClose.on('click', function(){
            const tl = gsap.timeline({ onComplete: blurSearch });
            tl.to($mobileUi, { duration: .2, autoAlpha: 0 }, 0);
            tl.to($searchToggle, { x: 0, duration: .35 }, .2);
            tl.to($menuToggle, { x: 0, autoAlpha: 1, duration: .35 }, .2);
            $('body').removeClass('search-open');
        });
    }
    //////////// MOBILE SEARCH

    //////////// NESTED DRAWERS
    const $drawer = $('nav.drawer');
    const $currentCollectionMenu = $drawer.find('[data-current-collection-menu]');

    const openChildMenu = function() {
        const connectedMenuId = $(this).attr('data-child-menu');
        const $connectedMenu = $('[data-parent-menu="'+ connectedMenuId +'"]');

        if ($connectedMenu.length){
            gsap.timeline()
            .set($connectedMenu, { display: 'block', autoAlpha: 1 })
            .to($connectedMenu, { x: 0, duration: .35 });
        }
    };

    const closeChildMenu = function() {
        const $connectedMenu = $(this).closest('[data-parent-menu]');

        if ($connectedMenu.length){
            gsap.timeline()
            .to($connectedMenu, { x: '100%', duration: .35 })
            .set($connectedMenu, { display: 'none', autoAlpha: 0 });
        }
    }

    $drawer.on('click', '[data-child-menu]', openChildMenu);
    $drawer.on('click', '[data-close-child-menu]', closeChildMenu);

    // Opening current category menu
    if($currentCollectionMenu.length) {
        openChildMenu.call($currentCollectionMenu);
    }
    //////////// NESTED DRAWERS

    const searchBoxTop = function() {

        const siteHeaderHeight = $('.site-header').height();
        const $searchBox = $('.search-box-container');

        if ($searchBox.length && $searchBox[0].style.opacity === "1") {
            $searchBox.css("transform", "translate(0px, " + siteHeaderHeight + "px)");
        }

    }
    $(window).on('resize', throttle(searchBoxTop, 100));

})(jQuery, window);
